<template>
<div>
	<v-dialog title="停课设置" v-model="hideShow" width="600" persistent scrollable>
		<v-card class="fc-dialog-card mg-dialog">
			<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-cog-outline</v-icon></span><div class="mg-dialog-title"><h2><span>停课设置</span></h2><p>完善信息后保存修改</p></div><v-spacer/><v-btn icon aria-label="关闭停课设置" @click="cancel"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

			<v-card-text class="fc-dialog-body">
				<v-row dense>
					<v-col cols="12">
						<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="add.post.dateFrom" label="停课开始日期" readonly v-bind="attrs" v-on="on"
									dense clearable outlined color="#d9363e" aria-label="停课开始日期" ></v-text-field>
							</template>
							<v-date-picker v-model="add.post.dateFrom" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
							</v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="12">
						<v-menu ref="menu1" v-model="menu2" :close-on-content-click="false"
							transition="scale-transition" offset-y min-width="auto">
							<template v-slot:activator="{ on, attrs }">
								<v-text-field v-model="add.post.dateTo" label="停课结束日期" readonly v-bind="attrs" v-on="on"
									dense clearable outlined color="#d9363e" aria-label="停课结束日期" ></v-text-field>
							</template>
							<v-date-picker v-model="add.post.dateTo" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
							</v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="12">
						<v-text-field v-model="add.post.stopReason" label="停课原因" dense clearable outlined color="#d9363e" aria-label="停课原因" ></v-text-field>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="fc-dialog-actions">
				<v-spacer></v-spacer>
				<v-btn @click="cancel" depressed>取消</v-btn>
				<v-btn @click="submitAdd" :loading="add.submiting" color="#d9363e" depressed class="fc-confirm">确定</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
 </div>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"set-shop-stop",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
			},
		},
		data(){
			return {
				menu1:false,
				menu2:false,
				shopId:"",
				add: {
					submiting:false,
					post:{
						dateFrom:"",
						stopReason:"",
						dateTo:"",
					}
				},
				hideShow:this.show,
			}
		},
		mounted() {
			this.shopId = utils.getCurrentShopId();
			console.log("set-shop-stop mounted");
		},
		methods:{
			
			submitAdd() {
				
				if (!this.add.post.dateFrom) {
					this.$noty.error('开始日期不能为空');
					return
				}
				
				if (!this.add.post.dateTo) {
					this.$noty.error('结束日期不能为空');
					return
				}
				this.add.submiting = true;
				// api
				const that = this;
				let url = `/sys/shop/stop/date/add`;
				let postData = this.add.post;
				postData.shopId = this.shopId;
			
			
				this.axios.post(url, postData).catch(() => {
					that.add.submiting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							that.add.submiting = false;
							that.$emit("success","");
							return;
						} else {
							that.add.submiting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.add.submiting = false;
						that.$noty.error('网络请求失败');
					}
				});
			},
			cancel(){
				this.$emit("cancel","");
			}
		}
	}
	
</script>
<style>
</style>
<style lang="scss" scoped src="../assets/styles/management.scss"></style>
